//general
export const GEOLOCATION_TIMEOUT = 60000;
export const GOOGLE_API_KEY = "AIzaSyDSczyya2X9YkyrBwaCDf5jR9xB-lDWOeU";
export const AVWX_API_KEY = "W98JfvawPP1_WIt3uQe4DEnmKDmgjZa0tkMcXqvK2pU";
export const INITIAL_METAR_COUNT = 10;
export const MILLISECONDS_PER_MINUTE = 60000;

//actions
export const REQUEST_GEOLOCATION = "REQUEST_GEOLOCATION";
export const REQUEST_GEOLOCATION_SUCCESS = "REQUEST_GEOLOCATION_SUCCESS";
export const REQUEST_GEOLOCATION_FAILURE = "REQUEST_GEOLOCATION_FAILURE";
export const UPDATE_METAR_LOCATION = "UPDATE_METAR_LOCATION";
export const UPDATE_METAR = "UPDATE_METAR";
export const UPDATE_METAR_SUCCESS = "UPDATE_METAR_SUCCESS";
export const UPDATE_METAR_FAILURE = "UPDATE_METAR_FAILURE";
export const ADD_EPHEMERAL_METAR = "ADD_EPHEMERAL_METAR";

//weather phenomena
export const WEATHER_PHENOMENA = [
  { type: "other", code: "+FC", name: "Tornado/Water Spout" },
  { type: "intensity", code: "-", name: "Light" },
  { type: "intensity", code: "+", name: "Heavy" },
  { type: "descriptor", code: "MI", name: "Shallow" },
  { type: "descriptor", code: "BL", name: "Blowing" },
  { type: "descriptor", code: "BC", name: "Patches" },
  { type: "descriptor", code: "PR", name: "Partial" },
  { type: "descriptor", code: "DR", name: "Drifting" },
  { type: "descriptor", code: "TS", name: "Thunderstorm" },
  { type: "descriptor", code: "FZ", name: "Freezing" },
  { type: "precipitation", code: "DZ", name: "Drizzle" },
  { type: "precipitation", code: "IC", name: "Ice Crystals" },
  { type: "precipitation", code: "UP", name: "Unknown Precipitation" },
  { type: "precipitation", code: "RA", name: "Rain" },
  { type: "precipitation", code: "PL", name: "Ice Pellets" },
  { type: "precipitation", code: "SN", name: "Snow" },
  { type: "precipitation", code: "GR", name: "Hail" },
  { type: "precipitation", code: "SG", name: "Snow Grains" },
  { type: "precipitation", code: "GS", name: "Small Hail/Snow Pellets" },
  { type: "obscuration", code: "FG", name: "Fog" },
  { type: "obscuration", code: "BR", name: "Mist" },
  { type: "obscuration", code: "SA", name: "Sand" },
  { type: "obscuration", code: "FU", name: "Smoke" },
  { type: "obscuration", code: "HZ", name: "Haze" },
  { type: "obscuration", code: "VA", name: "Volcanic Ash" },
  { type: "obscuration", code: "PY", name: "Spray" },
  { type: "obscuration", code: "DU", name: "Widespread Dust" },
  { type: "other", code: "SQ", name: "Squall" },
  { type: "other", code: "FC", name: "Funnel Cloud" },
  { type: "other", code: "SS", name: "Sandstorm" },
  { type: "other", code: "DS", name: "Duststorm" },
  { type: "other", code: "PO", name: "Well Developed Dust/Sand Whirls" },
  { type: "descriptor", code: "SH", name: "Showers" },
  { type: "proximity", code: "VC", name: "In the Vicinity" }
];



// WEBPACK FOOTER //
// ./src/util/constants.js